import * as React from 'react';
import LandingHomePage from '../layouts/LandingHomePage';
import { UserDetail } from '../../reducers/user';
import { Snackbar } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { SearchValue, NotificationsType } from 'src/reducers/landingPage';
import { UserProfileData } from '../../reducers/userProfile';

export interface LandingPageProps {
    onComponentDidMount: (userDetail: UserDetail) => void;
    oncomponentWillUnmount: () => void;
    onComponentWillMount: () => void;
    onSubmit: () => void;
    addNewOrder: () => void;
    MUploadOrder: () => void;
    goHome: () => void;
    feedback: () => void;
    profilePage: () => void;
    logout: () => void;
    draftOrder: () => void;
    newOrder: () => void;
    liveOrder: () => void;
    completeOrder: () => void;
    manucompletedOrder: () => void;
    orderrawdata: () => void;
    completeOrderDate: () => void;
    ordersOnHold: () => void;
    ordersReturned: () => void;
    cancelOrder: () => void;
    mOnHold: () => void;
    mUnderDesign: () => void;
    mDesignReady: () => void;
    mnewcase: () => void;
    mproduction: () => void;
    mcompleted: () => void;
    cfilterOrder: () => void;
    mfilterOrder: () => void;
    mfilterLessOrder: () => void;
    goUserAccount: () => void;
    goSupport: () => void;
    goFeedback: () => void;

    userDetails: UserDetail;
    loginSuccessAlert: string;
    loginFailureAlert: string;
    errorfilemsg: string;
    errorFileUploadedOpen: boolean;
    successfilemsg: string;
    successFileUploadOpen: boolean;
    successsubmitmsg: string;
    successSubmitOpen: boolean;
    handleClose: () => void;
    handleCloseAlert: () => void;
    searchName: (searchName: string) => void;
    searchNameText: string;
    searchResult: SearchValue[];
    onViewOrder: (orderid: string, rowData: string) => void;
    searchTrue: boolean;
    searchType: (searchType: string) => void;
    searchTypeName: string;

    userProfileData: UserProfileData;

    notifications: NotificationsType[];
    notificationsCount: Number;
    readNotifications: (messageId: string) => void;
    goNotification: () => void;
    goPayment: () => void;
    goPaidInvoice: () => void;
    goMyinvoices: () => void;
    goDesignPreference: () => void;
    goMaterialFiles: () => void;
    
    openVideoPlayer: boolean;
    loader: boolean;
    videoSignedUrl: string[];
    closeVideoPlayer: () => void;
}

class LandingPage extends React.Component<LandingPageProps> {
    render() {
        return (
            <div>
                <LandingHomePage
                    userDetails={this.props.userDetails}
                    goHome={this.props.goHome}
                    addNewOrder={this.props.addNewOrder}
                    MUploadOrder={this.props.MUploadOrder}
                    feedback={this.props.feedback}
                    btnElement={'Test'}
                    logout={this.props.logout}
                    newOrder={this.props.newOrder}
                    draftOrder={this.props.draftOrder}
                    liveOrder={this.props.liveOrder}
                    completeOrder={this.props.completeOrder}
                    manucompletedOrder={this.props.manucompletedOrder}
                    orderrawdata={this.props.orderrawdata}
                    completeOrderDate={this.props.completeOrderDate}
                    mOnHold={this.props.mOnHold}
                    mUnderDesign={this.props.mUnderDesign}
                    mDesignReady={this.props.mDesignReady}
                    mnewcase={this.props.mnewcase}
                    mproduction={this.props.mproduction}
                    mcompleted={this.props.mcompleted}
                    cfilterOrder={this.props.cfilterOrder}
                    mfilterOrder={this.props.mfilterOrder}
                    mfilterLessOrder={this.props.mfilterLessOrder}
                    profilePage={this.props.profilePage}
                    goUserAccount={this.props.goUserAccount}
                    ordersOnHold={this.props.ordersOnHold}
                    ordersReturned={this.props.ordersReturned}
                    cancelOrder={this.props.cancelOrder}
                    goSupport={this.props.goSupport}
                    goFeedback={this.props.goFeedback}
                    searchName={this.props.searchName}
                    searchResult={this.props.searchResult}
                    onViewOrder={this.props.onViewOrder}
                    searchTrue={this.props.searchTrue}
                    searchNameText={this.props.searchNameText}
                    searchType={this.props.searchType}
                    searchTypeName={this.props.searchTypeName}
                    notifications={this.props.notifications}
                    notificationsCount={this.props.notificationsCount}
                    readNotifications={this.props.readNotifications}
                    goNotification={this.props.goNotification}
                    goPayment={this.props.goPayment}
                    goMyinvoices={this.props.goMyinvoices}
                    goPaidInvoice={this.props.goPaidInvoice}
                    goDesignPreference={this.props.goDesignPreference}
                    goMaterialFiles={this.props.goMaterialFiles}
                    openVideoPlayer={this.props.openVideoPlayer}
                    videoSignedUrl={this.props.videoSignedUrl}
                    closeVideoPlayer={this.props.closeVideoPlayer}
                    userProfileData={this.props.userProfileData}
                    loader={this.props.loader}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    transitionDuration={1000}
                    open={this.props.successSubmitOpen}
                    autoHideDuration={2000}
                    onClose={this.props.handleClose}
                >
                    <Alert severity="success" onClose={this.props.handleClose}>
                        <AlertTitle>The user got logged in</AlertTitle>
                        {this.props.successsubmitmsg}
                    </Alert>
                </Snackbar>
                {/* <------------------------------------------------------Error Message---------------------------------> */}
                <Snackbar
                    open={this.props.errorFileUploadedOpen}
                    autoHideDuration={3000}
                    transitionDuration={1000}
                    onClose={this.props.handleCloseAlert}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="error"
                        onClose={this.props.handleCloseAlert}
                    >
                        <AlertTitle>Error</AlertTitle>
                        {this.props.errorfilemsg}
                    </Alert>
                </Snackbar>
                {/* <------------------------------------------------------Success Message---------------------------------> */}
                <Snackbar
                    open={this.props.successFileUploadOpen}
                    autoHideDuration={3000}
                    transitionDuration={1000}
                    onClose={this.props.handleCloseAlert}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="success"
                        onClose={this.props.handleCloseAlert}
                    >
                        <AlertTitle>Success</AlertTitle>
                        {this.props.successfilemsg}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount(this.props.userDetails);
    }
    componentWillUnmount() {
        // const url: string = window.location.href;
        this.props.oncomponentWillUnmount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/landingPage/LandingPage.tsx